var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section-vue',{staticClass:"business-app-screen"},[_c('div',{staticClass:"business-app-screen__container container"},[_c('div',{staticClass:"business-app-screen__body grid-css"},[_c('pict',{attrs:{"block-name":"business-app-screen","default":{
          src: _vm.$options.image[_vm.$i18n.locale]['1x'],
          srcset: {
            '2x': _vm.$options.image[_vm.$i18n.locale]['2x']
          }
        }}}),_vm._v(" "),_c('div',{staticClass:"business-app-screen__copy"},[_c('h2',{staticClass:"business-app-screen__headline"},[_vm._v("\n          "+_vm._s(_vm.$t("headline"))+"\n        ")]),_vm._v(" "),_c('ul',{staticClass:"business-app-screen__highlights",domProps:{"innerHTML":_vm._s(
            _vm.$t('highlights', {
              totalBooks: _vm.$options.totalBooks,
              totalCategories: _vm.$options.totalCategories
            })
          )}})])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }